import { render, staticRenderFns } from "./reMainMenu.vue?vue&type=template&id=55f8e89c&scoped=true&"
import script from "./reMainMenu.vue?vue&type=script&lang=js&"
export * from "./reMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./reMainMenu.vue?vue&type=style&index=0&id=55f8e89c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8e89c",
  null
  
)

export default component.exports